const errorLogger = (error: unknown) => {
  // eslint-disable-next-line no-console
  console.log(error);
};

export default errorLogger;
